export default __webpack_public_path__ + "static/media/ChienMaTVSI.99e1a978.jpg";